import * as ArcGIS from './ArcGIS'
import DateService from './DateService'

// TODO: IMPORTANTE -> VIS.JS no soporta nativamente DayJS asi que es necesario pasar las fechas en otro formato (string, unix, etc) por eso se usa .valueOf()
// ¿Quiza algun dia esto no haga falta?
export const convertDatesToUNIX = (items) =>
  items.map((item) => {
    const newItem = { ...item }

    if (newItem.start) newItem.start = DateService.toDayjs(newItem.start).valueOf()
    if (newItem.end) newItem.end = DateService.toDayjs(newItem.end).valueOf()

    if (newItem.type !== 'background') {
      newItem.style = 'height: 30px'
    }

    return newItem
  })

// Función para calcular el tiempo de viaje de un medio a un incendio usando la velocidad máxima del medio
export const calculateDistanceInfraestructuraToIncendio = (infraestructura, incendio, velocidadMaxima) => {
  if (!infraestructura?.X || !infraestructura?.Y || !incendio?.LATITUD || !incendio?.LONGITUD || !velocidadMaxima) {
    return null
  }

  // Convertir lat/lon del incendio a coordenadas ETRS89
  const [x1, y1] = ArcGIS.convertirLatLonToETRS89(incendio.LATITUD, incendio.LONGITUD)
  const x2 = infraestructura.X
  const y2 = infraestructura.Y

  const distanciaKm = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2)) / 1000

  const tiempoHoras = distanciaKm / velocidadMaxima
  const tiempoMinutos = tiempoHoras * 60

  return Math.round(tiempoMinutos)
}

// Metodo que comprueba si las fechas del medio_sector es a futuro o real
export const comprobarFechas = (medioSector, currentDate) => {
  if (medioSector.FECHA_ALARMADO > currentDate) {
    medioSector.FECHA_ALARMADO = null
  }
  if (medioSector.FECHA_EN_CAMINO > currentDate) {
    medioSector.FECHA_EN_CAMINO = null
  }
  if (medioSector.FECHA_EN_LUGAR > currentDate) {
    medioSector.FECHA_EN_LUGAR = null
  }
  if (medioSector.FECHA_FINALIZADO > currentDate) {
    medioSector.FECHA_FINALIZADO = null
  }
  if (medioSector.FECHA_FIN_DESCANSO > currentDate) {
    medioSector.FECHA_FIN_DESCANSO = null
  }
  return medioSector
}

// Formatea la fecha del item en el timeline
export const formatTimelineFecha = (fecha) => {
  return fecha ? DateService.toDayjs(fecha).format('DD-MM-YYYY HH:mm') : DateService.getCurrentDayJs().format('YYYY-MM-DD HH:mm')
}

// Indica el grupo según el tipo de medio aéreo, TODO: pienso que el grupo se tendría que guardar en el backend
export const tipoGrupo = (tipo) => {
  if (/(ACO|AA|ACT)|Avi/.test(tipo)) return 'AVIONES'
  if (/(HE|HTE|HK|Heli)/.test(tipo)) return 'HELICOPTEROS'
  return 'MTA'
}
